import { AuthProvider } from "./AuthContext";
import { CloudProvider } from "./CloudContext";
import { AppConfigProvider } from "./AppConfigContext";

/**
 * Composite Provider Component
 * Combines all application contexts in the correct hierarchy:
 * - AuthProvider: Core authentication (Cognito user, tokens, service type)
 * - CloudProvider: Cloud service credentials (AWS, Cloudinary, Cesium)
 * - AppConfigProvider: Application configuration (storage limits)
 * 
 * This structure allows for better separation of concerns and easier testing
 */
export function AppProviders({ children }) {
  return (
    <AuthProvider>
      <CloudProvider>
        <AppConfigProvider>
          {children}
        </AppConfigProvider>
      </CloudProvider>
    </AuthProvider>
  );
}